import React from "react";
import Layout from "../../Layout";
import PhoneNumberSettingsContainer from "../../containers/PhoneNumberSettings";
import { Helmet } from "react-helmet";

export default function PhoneNumberSettingsPage() {
  return (
    <Layout>
      <Helmet>
        <title>Phone Number Settings - {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>
      <PhoneNumberSettingsContainer />
    </Layout>
  );
}

